import { render, staticRenderFns } from "./wokrspace-select.vue?vue&type=template&id=4f8d7e30&"
import script from "./wokrspace-select.vue?vue&type=script&lang=ts&"
export * from "./wokrspace-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports